import Breadcrumb from "components/Common/Breadcrumb"
import Loader from "components/Loader/loader"
import moment from "moment"
import React, { useEffect, useState } from "react"
import { FaEye } from "react-icons/fa"
import {
  Card,
  CardBody,
  Modal,
  ModalBody,
  ModalHeader,
  Table,
} from "reactstrap"
import { fetchData } from "utils/Common_api_functions"

const AuditLogs = () => {
  const [logs, setLogs] = useState([])
  const [loading, setLoading] = useState(false)
  const [logModal, setLogModal] = useState(false)
  const [selectedLog, setSelectedLog] = useState({})

  useEffect(() => {
    getLogs()
  }, [])

  async function getLogs() {
    const APIdata = await fetchData(setLoading, "logs")
    if (APIdata?.success) setLogs(APIdata?.data)
  }

  const parsedDescription = (() => {
    try {
      return JSON.parse(selectedLog?.description || "{}")
    } catch (e) {
      return null
    }
  })()

  const renderValue = value => {
    if (value === null || value === undefined) {
      return <span style={{ color: "#94a3b8", fontStyle: "italic" }}>null</span>
    }

    if (Array.isArray(value)) {
      if (value.length === 0) {
        return (
          <span
            style={{
              background: "#f1f5f9",
              borderRadius: "5px",
              padding: "2px 8px",
              fontSize: "12px",
              color: "#94a3b8",
            }}
          >
            Empty
          </span>
        )
      }
      if (typeof value[0] === "object" && value[0] !== null) {
        const columns = [...new Set(value.flatMap(obj => Object.keys(obj)))]
        return (
          <div style={{ overflowX: "auto", marginTop: "6px" }}>
            <Table
              bordered
              size="sm"
              style={{ fontSize: "12px", marginBottom: 0 }}
            >
              <thead style={{ background: "#f8faff" }}>
                <tr>
                  <th>#</th>
                  {columns.map(col => (
                    <th key={col} style={{ whiteSpace: "nowrap" }}>
                      {col.replace(/([A-Z])/g, " $1").trim()}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {value.map((row, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    {columns.map(col => (
                      <td key={col}>{renderValue(row[col])}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )
      }
      return (
        <div className="d-flex flex-wrap gap-1" style={{ marginTop: "4px" }}>
          {value.map((item, i) => (
            <span
              key={i}
              style={{
                background: "#f1f5f9",
                borderRadius: "6px",
                padding: "2px 10px",
                fontSize: "12px",
                color: "#475569",
              }}
            >
              {String(item)}
            </span>
          ))}
        </div>
      )
    }

    if (typeof value === "object") {
      return (
        <div
          style={{
            marginTop: "6px",
            paddingLeft: "12px",
            borderLeft: "2px solid #ede9fe",
          }}
        >
          {renderObject(value)}
        </div>
      )
    }

    if (typeof value === "boolean") {
      return (
        <span
          style={{
            background: value ? "#e8f5e9" : "#fdecea",
            color: value ? "#2e7d32" : "#EF5350",
            borderRadius: "6px",
            padding: "2px 10px",
            fontSize: "12px",
            fontWeight: 600,
          }}
        >
          {value ? "true" : "false"}
        </span>
      )
    }

    if (typeof value === "number") {
      return (
        <span
          style={{
            background: "#f0f4ff",
            color: "#6C63FF",
            borderRadius: "6px",
            padding: "2px 10px",
            fontSize: "12px",
            fontWeight: 600,
          }}
        >
          {value}
        </span>
      )
    }

    return <span style={{ fontSize: "13px" }}>{String(value)}</span>
  }

  const renderObject = obj => {
    return (
      <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
        {Object.entries(obj).map(([key, val]) => {
          const isNested =
            typeof val === "object" && val !== null && !Array.isArray(val)
          const isArrayOfObjects =
            Array.isArray(val) && val.length > 0 && typeof val[0] === "object"

          return (
            <div key={key}>
              <div
                style={{
                  fontSize: "13px",
                  fontWeight: 600,
                  color: isNested || isArrayOfObjects ? "#6C63FF" : "#475569",
                  marginBottom: isNested || isArrayOfObjects ? "4px" : "0",
                  display: "flex",
                  alignItems:
                    isNested || isArrayOfObjects ? "center" : "baseline",
                  gap: "8px",
                }}
              >
                <span>
                  {key.replace(/([A-Z])/g, " $1").trim()}
                  {(isNested || isArrayOfObjects) && (
                    <span style={{ color: "#c4b5fd", marginLeft: "2px" }}>
                      /
                    </span>
                  )}
                </span>
                {!isNested && !isArrayOfObjects && renderValue(val)}
              </div>

              {(isNested || isArrayOfObjects) && (
                <div
                  style={{
                    paddingLeft: "14px",
                    borderLeft: "2px solid #ede9fe",
                  }}
                >
                  {renderValue(val)}
                </div>
              )}
            </div>
          )
        })}
      </div>
    )
  }

  return (
    <div className="page-content">
      {loading && <Loader />}
      <Breadcrumb title="Dashboard" breadcrumbItem="Sheet Logs" />
      <Card className="border-0 shadow-sm">
        <CardBody style={{ padding: "20px" }}>
          {/* Card Header */}
          <div className="d-flex align-items-center justify-content-between mb-3">
            <div className="d-flex align-items-center gap-2">
              <div
                className="d-flex align-items-center justify-content-center"
                style={{
                  width: "38px",
                  height: "38px",
                  borderRadius: "10px",
                  background: "#eef0ff",
                  color: "#556ee6",
                }}
              >
                <FaEye size={16} />
              </div>
              <div>
                <h5 className="mb-0 fw-semibold">Audit Logs</h5>
                <span style={{ fontSize: "12px", color: "#94a3b8" }}>
                  {logs?.length || 0} total records
                </span>
              </div>
            </div>
          </div>

          <div
            style={{
              border: "1px solid #eef0f6",
              borderRadius: "12px",
              overflow: "hidden",
            }}
          >
            <Table responsive hover style={{ marginBottom: 0 }}>
              <thead>
                <tr style={{ background: "#f8faff" }}>
                  <th
                    style={{
                      padding: "14px 18px",
                      fontSize: "12px",
                      fontWeight: 600,
                      color: "#64748b",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      whiteSpace: "nowrap",
                      width: "60px",
                    }}
                  >
                    #
                  </th>
                  <th
                    style={{
                      padding: "14px 18px",
                      fontSize: "12px",
                      fontWeight: 600,
                      color: "#64748b",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Action
                  </th>
                  <th
                    style={{
                      padding: "14px 18px",
                      fontSize: "12px",
                      fontWeight: 600,
                      color: "#64748b",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Performed By
                  </th>
                  <th
                    style={{
                      padding: "14px 18px",
                      fontSize: "12px",
                      fontWeight: 600,
                      color: "#64748b",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Performed At
                  </th>
                  <th
                    style={{
                      padding: "14px 18px",
                      fontSize: "12px",
                      fontWeight: 600,
                      color: "#64748b",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      textAlign: "center",
                      width: "90px",
                    }}
                  >
                    View
                  </th>
                </tr>
              </thead>
              <tbody>
                {logs?.length === 0 ? (
                  <tr>
                    <td colSpan="4" className="text-center py-5">
                      <div
                        className="mx-auto mb-3 d-flex align-items-center justify-content-center rounded-circle"
                        style={{
                          width: "56px",
                          height: "56px",
                          background: "#f1f5f9",
                        }}
                      >
                        <FaEye size={22} style={{ color: "#94a3b8" }} />
                      </div>
                      <p
                        className="mb-0"
                        style={{ fontSize: "13px", color: "#94a3b8" }}
                      >
                        No audit logs found
                      </p>
                    </td>
                  </tr>
                ) : (
                  logs?.map((item, index) => (
                    <tr key={index}>
                      <td
                        style={{
                          padding: "14px 18px",
                          fontSize: "13px",
                          color: "#94a3b8",
                          verticalAlign: "middle",
                        }}
                      >
                        {index + 1}
                      </td>
                      <td
                        style={{
                          padding: "14px 18px",
                          verticalAlign: "middle",
                        }}
                      >
                        <span
                          className="badge"
                          style={{
                            background: "#eef0ff",
                            color: "#0178ad",
                            fontSize: "11.5px",
                            fontWeight: 600,
                            padding: "5px 12px",
                            borderRadius: "20px",
                            textTransform: "capitalize",
                          }}
                        >
                          {item?.action || "—"}
                        </span>
                      </td>
                                            <td
                        style={{
                          padding: "14px 18px",
                          verticalAlign: "middle",
                        }}
                      >
                        <span
                          className="badge"
                          style={{
                            background: "#0178ad",
                            color: "white",
                            fontSize: "11.5px",
                            fontWeight: 500,
                            padding: "5px 12px",
                            borderRadius: "20px",
                            textTransform: "capitalize",
                          }}
                        >
                          {item?.performedBy.name || "—"}
                        </span>
                      </td>
                      <td
                        style={{
                          padding: "14px 18px",
                          fontSize: "13px",
                          color: "#475569",
                          whiteSpace: "nowrap",
                          verticalAlign: "middle",
                        }}
                      >
                        {moment(item?.createdAt).format("DD MMM YYYY, hh:mm A")}
                      </td>
                      <td
                        style={{
                          padding: "14px 18px",
                          textAlign: "center",
                          verticalAlign: "middle",
                        }}
                      >
                        <button
                          className="btn btn-sm d-inline-flex align-items-center justify-content-center border-0"
                          title="View Log Details"
                          onClick={() => {
                            setSelectedLog(item)
                            setLogModal(true)
                          }}
                          style={{
                            width: "34px",
                            height: "34px",
                            borderRadius: "8px",
                            background: "#eef0ff",
                            color: "#556ee6",
                            transition: "all 0.15s ease",
                          }}
                          onMouseEnter={e => {
                            e.currentTarget.style.background = "#556ee6"
                            e.currentTarget.style.color = "#fff"
                          }}
                          onMouseLeave={e => {
                            e.currentTarget.style.background = "#eef0ff"
                            e.currentTarget.style.color = "#556ee6"
                          }}
                        >
                          <FaEye size={14} />
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>

      <Modal isOpen={logModal} size="lg" scrollable>
        <ModalHeader toggle={() => setLogModal(false)}>Log Details</ModalHeader>
        <ModalBody style={{ padding: "20px" }}>
          {parsedDescription ? (
            <div
              style={{
                background: "#f8faff",
                borderRadius: "10px",
                border: "1px solid #ede9fe",
                overflow: "hidden",
                padding: "10px",
              }}
            >
              {renderObject(parsedDescription)}
            </div>
          ) : (
            <p style={{ fontSize: "13px", color: "#64748b" }}>
              {selectedLog?.description || "No description available."}
            </p>
          )}
        </ModalBody>
      </Modal>
    </div>
  )
}

export default AuditLogs
